<template>
  <div class="home">
    <q-row class="content_row">
      <q-col class="item_col" cols="3">
        <q-button
          type="default"
          theme="secondary"
          size="medium"
          @click="onCompetitorLoginClick"
        >Войти как участник</q-button>
        <br />
        <q-button
          type="default"
          theme="link"
          size="medium"
          @click="onCompetitorRegisterClick"
        >Зарегистрироваться</q-button>
      </q-col>
      <q-col class="item_col" cols="3" offset="6">
        <q-button
          type="default"
          theme="secondary"
          size="medium"
          @click="onHostLoginClick"
        >Войти как ведущий</q-button>
        <br />
        <q-button
          type="default"
          theme="link"
          size="medium"
          @click="onHostRegisterClick"
        >Зарегистрироваться</q-button>
      </q-col>
    </q-row>
  </div>
</template>
<script>
import Vue from "vue";
import { QDialog, QMessageBox } from "@qvant/qui";
import gql from "graphql-tag";

export default {
  name: "Home",
  // components: { Post },
  apollo: {
    posts: {
      query: gql`
        query GetAllPosts {
          getAllPosts(limit: 12) {
            imageUrl
            text
            likes
            _id
          }
        }
      `,
      update: data => data.getAllPosts,
      pollInterval: 5000
    }
  },
  methods: {
    async onCompetitorLoginClick() {
      const { answer, instance } = QMessageBox.bind(Vue)({
        component: () => import("../components/Home/CompetitorLoginDialog"),
        ...this.$props,
          title: 'Войти в качестве участника',
          closeOnClickShadow: false
      });
      this.dialogInstance = instance;
    },
    async onCompetitorRegisterClick() {
      const { answer, instance } = QMessageBox.bind(Vue)({
        component: () => import("../components/Home/CompetitorRegisterDialog"),
        ...this.$props,
          title: 'Зарегистрироваться в качестве участника',
          closeOnClickShadow: false
      });

      this.dialogInstance = instance;

      console.log("instance", instance);
      console.log("answer", await answer);
    },
    async onHostLoginClick() {
      const { answer, instance } = QMessageBox.bind(Vue)({
        component: () => import("../components/Home/HostLoginDialog"),
        ...this.$props,
          title: 'Войти в качестве ведущего',
          closeOnClickShadow: false
      });

      this.dialogInstance = instance;

      console.log("instance", instance);
      console.log("answer", await answer);
    },
    async onHostRegisterClick() {
      const { answer, instance } = QMessageBox.bind(Vue)({
        component: () => import("../components/Home/HostRegisterDialog"),
        ...this.$props,
          title: 'Зарегистрироваться в качестве ведущего',
          closeOnClickShadow: false
      });

      this.dialogInstance = instance;

      console.log("instance", instance);
      console.log("answer", await answer);
    },
    onLike({ _id }) {
      this.$apollo.mutate({
        mutation: gql`
          mutation AddLike($id: ID!) {
            addLike(id: $id)
          }
        `,
        variables: {
          id: _id
        }
      });
    },
    onDislike({ _id }) {
      this.$apollo.mutate({
        mutation: gql`
          mutation RemoveLike($id: ID!) {
            removeLike(id: $id)
          }
        `,
        variables: {
          id: _id
        }
      });
    }
  }
};
</script>

<style>
.home {
  background-image: url("/img/home.svg");
  background-position-x: center;
  background-position-y: bottom;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100vw;
  height: auto;
  min-height: 80vh;
  display: flex;
  justify-content: space-evenly;
  padding: 32px 0;
}
.item_col {
  text-align: center;
}
</style>
